import { StatsDependenciesFactory } from "./dependencies.factory";

export const statsEpicDependencies = {
    statsService: StatsDependenciesFactory.getStatsService()
}
